/**
 * cart-drawer-render-fix.js
 *
 * Fixes: after Add to Cart, the item is genuinely added (verified via
 * /cart.js) but doesn't appear in the drawer's [data-products] container
 * until a hard refresh.
 *
 * Confirmed root cause (read directly from theme.js): theme.CartDrawer
 * listens for two different events on `document` -
 *   - 'cart:open'        -> only opens the drawer, no re-render
 *   - 'ajaxProduct:added' -> calls cartForm.buildCart() AND opens the
 *                            drawer
 * Any add-to-cart code path that dispatches 'cart:open' (or nothing at
 * all) instead of 'ajaxProduct:added' after a successful /cart/add.js
 * call will open the drawer showing stale markup, exactly matching the
 * hard-refresh symptom. The silk-satin-bedsheet PDP's custom add-to-cart
 * handler was one such path (fixed directly in its section file), but
 * this watchdog is kept as a generic safety net for any other add-to-cart
 * entry point with the same gap.
 *
 * It wraps window.fetch and, shortly after any successful call to
 * /cart/add.js, dispatches the real 'ajaxProduct:added' event that
 * theme.js's own CartDrawer already listens for - not a guessed internal
 * API call. If the page already dispatched it correctly, this is a
 * harmless redundant re-render of the same markup.
 */
(function () {
  if (window.__cartDrawerRenderFix) return;
  window.__cartDrawerRenderFix = true;

  var WATCHDOG_DELAY_MS = 300;
  var CART_ADD_URL_RE = /\/cart\/add(\.js)?(\?.*)?$/;

  function notifyCartDrawer() {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch !== 'function') return;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartAdd = CART_ADD_URL_RE.test(url);
    var result = originalFetch.apply(this, arguments);
    if (isCartAdd) {
      result.then(function (response) {
        if (response && response.ok) {
          setTimeout(notifyCartDrawer, WATCHDOG_DELAY_MS);
        }
      }).catch(function () {
        /* network/theme error - nothing for the watchdog to do */
      });
    }
    return result;
  };
})();
